import React from 'react';

/** Comp-faithful profile card (`.card` + `.ch`). Header is mono-uppercase with an icon + optional meta. */
export const ProfileCard: React.FC<{
  icon?: React.ReactNode;
  title: string;
  meta?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}> = ({ icon, title, meta, children, className = '' }) => (
  <div className={`overflow-hidden rounded-xl border border-border bg-surface ${className}`}>
    <div className="flex items-center justify-between gap-2.5 border-b border-border bg-surface-alt px-4 py-3">
      <div className="flex items-center gap-2 font-mono text-[10.5px] uppercase tracking-wider text-muted">
        {icon && <span className="text-faint">{icon}</span>}
        {title}
      </div>
      {meta && <div className="font-mono text-[10.5px] text-faint">{meta}</div>}
    </div>
    {children}
  </div>
);
